export const videoSettings = {
  // note: do not set height or width as it causes an issue on some endpoints with Edge
  aspectRatio: {
    exact: 4 / 3,
  },
  frameRate: { min: 20, ideal: 30, max: 30 },
};
